import { render } from "@/components/pages/individualWorkSupport/requirement047/Requirement047.html?vue&type=template&id=e3c2eabc&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement047/Requirement047.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement047/Requirement047.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement047/Requirement047.scss?vue&type=style&index=0&id=e3c2eabc&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c2eabc"]])

export default __exports__